/**
 * Wall-clock idle threshold: no user activity (tab:activity / tab:active refresh)
 * for this long ⇒ tab rotation + heartbeat suspension share this constant.
 */
export const USER_IDLE_THRESHOLD_MS = 30 * 60 * 1000;
